import { Link } from "react-router-dom";

interface Comic {
  id: string;
  title: string;
  author: string;
  cover: string;
  category: string;
  rating: number;
  views: number;
  tags: string[];
  updateDate: string;
}

interface ComicCardProps {
  comic: Comic;
  size?: "default" | "large";
}

export default function ComicCard({ comic, size = "default" }: ComicCardProps) {
  const formatViews = (views: number) => {
    if (views >= 10000) {
      return `${(views / 10000).toFixed(1)}万`;
    }
    return views.toString();
  };

  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block cursor-pointer"
      data-product-shop=""
    >
      <div
        className={`relative overflow-hidden rounded-lg bg-background-100 ${
          size === "large" ? "aspect-[3/4]" : "aspect-[2/3]"
        }`}
      >
        <img
          src={comic.cover}
          alt={comic.title}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <p className="text-white text-xs line-clamp-3 leading-relaxed">
            {comic.tags.join(" · ")}
          </p>
        </div>
        <div className="absolute top-2 left-2 flex items-center gap-1 bg-primary-500/90 text-background-50 text-xs font-medium px-2 py-0.5 rounded-full">
          <i className="ri-star-fill text-[10px] w-3 h-3 flex items-center justify-center"></i>
          {comic.rating}
        </div>
      </div>
      <div className="mt-2.5 space-y-1">
        <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors duration-200 line-clamp-1">
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 line-clamp-1">
          {comic.author}
        </p>
        <div className="flex items-center gap-3 text-xs text-foreground-400">
          <span className="flex items-center gap-1">
            <i className="ri-eye-line w-3 h-3 flex items-center justify-center"></i>
            {formatViews(comic.views)}
          </span>
          <span>{comic.updateDate}</span>
        </div>
      </div>
    </Link>
  );
}